import { render, staticRenderFns } from "./DriverAssign.vue?vue&type=template&id=1337a5a1&scoped=true&"
import script from "./DriverAssign.vue?vue&type=script&lang=js&"
export * from "./DriverAssign.vue?vue&type=script&lang=js&"
import style0 from "./DriverAssign.vue?vue&type=style&index=0&id=1337a5a1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1337a5a1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VCard,VDialog,VTextField})
